import React, { useState, useEffect } from 'react';
import './vocal-menu.css';
import { useSelector, useDispatch } from 'react-redux';
import { 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer,
    TableHead, 
    TableRow, 
    Paper,
} from '@mui/material';
import TracksPlayPauseButton from '../tracks-play-pause/tracks-play-pause';
// import { cleanTrackName } from '../../utils/utils';
import { setVoxAuthDialogVisible } from '../../features/dialogControl/dialogControlSlice';
import { useTheme } from '@mui/material/styles';
import { GET_VOCAL_MENU_TRACKS} from '../../config/queries';
import { graphqlRequest } from '../../services/graphql-service';
import { selectTrack, setPlaylist } from '../../features/audioPlayer/audioPlayerSlice';
import { timeout, playDelay } from '../../utils/utils';
import { usePub } from '../../hooks/usePubSub';


const VocalMenu = () => {
	const dispatch = useDispatch();
	const theme = useTheme();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [isBlurred, setIsBlurred] = useState(true);
	const [tracksData,setTracksData] = useState([]);
	const currentTrack = useSelector(state => state.audioPlayer.currentTrack);
	const trackIsPlaying = useSelector(state => state.audioPlayer.trackIsPlaying);
	const publish = usePub();
	
	// blur if not logged in
	useEffect(() => {
			const user = JSON.parse(localStorage.getItem('mb-vox-auth'));
			if (user) {
					setIsBlurred(false);
			} else {
                setIsBlurred(true);
                dispatch(setVoxAuthDialogVisible(true)); 
			}
	}, [dispatch]);

	useEffect(() => {
		const fetchTracksData = async () => {
            try {
                setLoading(true);
                const data = await graphqlRequest(GET_VOCAL_MENU_TRACKS, {}); 
                setTracksData(data.vocal_tracks);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
		};
	
		fetchTracksData();
	}, []);

	const handleSongSelect = async (event,track) => {
		event.stopPropagation();
		let changedSelection = false;
			
		// select the track if it is not the current track
		if (!currentTrack || (currentTrack && currentTrack.id !== track.id)) {
			changedSelection = true;
			dispatch(selectTrack(track));
            dispatch(setPlaylist(tracksData));
		}
		// handle play/pause
		if (changedSelection) {
			await timeout(playDelay); // allow next audio source to load
			publish('audioPlayerEvent',{action:'play', track: track})
		} else {
			if (!trackIsPlaying) {
				publish('audioPlayerEvent',{action:'play', track: track})
			} else {
				publish('audioPlayerEvent',{action:'pause', track: track})
			}
		}
	};

	if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

	return (
		<div>
			{isBlurred && <div className="blurred-overlay"></div>}
			<div className='artist-list-banner'>Voice</div>
			<TableContainer 
                component={Paper} 
                sx={{ 
                    marginBottom: '90px',
                    backgroundColor: '#121212',
                    height: 'unset', // Ensure it does not enforce a height
                    overflow: 'visible', // Prevent scrollbars
                }}
            >
            <Table 
                stickyHeader
                sx={{
                    height: 'unset',
                    overflow: 'visible',
                }}              
            >
                <TableHead 
                    sx={{
                        zIndex: 2,
                        boxShadow: '0px 4px 6px -2px rgba(0, 0, 0, 0.1)',
                    }}
                >
                     <TableRow >
                        <TableCell sx={{
                            fontWeight : 'bold',
                            fontSize: '12px',
                            color: theme.palette.contentCopy,
							width:'80px'
                        }}></TableCell>
                        <TableCell sx={{
                            fontWeight : 'bold',
                            fontSize: '12px',
                            color: theme.palette.contentCopy,
                            // display: { 
                            //     xs: 'none',
                            //     sm: 'table-cell',
                            //     md: 'table-cell'
                            // },
                            width:'80px'
                        }}></TableCell>
                        <TableCell
                            sx={{
                            fontWeight : 'bold',
                            fontSize: '12px',
                            color: theme.palette.contentCopy,
                            // display: { 
                            //     xs: 'none',
                            //     md: 'table-cell'
                            // }
                        }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tracksData.map((t, index) => (
                        <TableRow 
                            key={index} 
                            className={`track-list-row ${t.id === currentTrack.id ? 'track-list-row-selected' : ''}`}
                            sx={{
                                cursor: 'pointer'
                            }}
                            onClick={(e) => handleSongSelect(e,t)}
                        >
                            <TableCell>
                              <img className='vox-artist-profile' src={`https://media.tracktribe.com/images/track_images/${t.image}`} alt={t.title}/>
                            </TableCell>
                            <TableCell
                                sx={{
                                    // display: { 
                                    //     xs: 'none',
                                    //     sm: 'table-cell',
                                    //     md: 'table-cell'
                                    // },
                                    alignItems:'center',
                                    justifyContent: 'center',
                                    textAlign: 'center'
                                }}
                            >
                                <TracksPlayPauseButton track={t} playlist={tracksData} large={true} />
                                
                            </TableCell>
                            <TableCell 
                                sx={{
                                    // display: { 
                                    //     xs: 'none',
                                    //     md: 'table-cell'
                                    // }
                                }}
                            >
                                <div className='vox-artist-title-block'>
                                    <div className='vox-artist-name'>{t.artist_name}</div>
                                    <div className='vox-track-title'>"{t.title}"</div>
                                    <div className='vox-genres-list'>{t.genres}</div>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
		</div>
	)
}

export default VocalMenu;